const filledFromSection =
  'bg-content-primary text-content-inverse border-transparent in-cw-dark-colorways:bg-content-inverse in-cw-dark-colorways:text-content-primary';
const filledOnLight = 'border-transparent bg-content-primary! text-content-inverse!';
const filledOnDark = 'border-transparent bg-content-inverse! text-content-primary!';

export function filledTagClassName(onDarkSurface?: boolean) {
  if (onDarkSurface === undefined) return filledFromSection;
  return onDarkSurface ? filledOnDark : filledOnLight;
}
